module.exports = __webpack_public_path__ + "img/background-install-app.d6175295.png";